// src/DuplicatePatronErrorModal.js
import React, { useState } from "react";
import "./DuplicatePatronErrorModal.css";

const DuplicatePatronErrorModal = ({
  errorData,
  organizationName,
  organizations = [],
  onBack,
}) => {
  const [copied, setCopied] = useState(false);

  // Look up the organization name for the existing organization
  const existingOrg = organizations.find(
    (org) => org.orgId === errorData.existingOrgId
  );
  const existingOrgName = existingOrg?.name || "Unknown Organization";

  const handleCopy = () => {
    const fullMessage = `Duplicate Patron Cannot Be Created\n\nThe user ${errorData.email} already exists in ${existingOrgName} (${errorData.existingOrgId}). This system prevents a user with the same email from being duplicated in ${organizationName} (${errorData.currentOrgId}). Please reach out to an administrator if this is an important requirement for this demo experience as this is not a Yonomi Platform limitation.`;
    navigator.clipboard.writeText(fullMessage).then(() => {
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    });
  };

  return (
    <div className="duplicate-error-overlay" onClick={onBack}>
      <div
        className="duplicate-error-modal"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="duplicate-error-header">
          <h2>❌ Duplicate Patron Cannot Be Created</h2>
          <button className="close-button" onClick={onBack}>
            ✕
          </button>
        </div>

        <div className="duplicate-error-content">
          <p className="error-message">
            The email <strong>{errorData.email}</strong> is already in use in an
            organization called <strong>{existingOrgName}</strong>. This system
            prevents a user with the same email from being duplicated in this
            organization (<strong>{organizationName}</strong>).
          </p>

          <p className="error-note">
            Please reach out to an administrator if this is an important
            requirement for this demo experience as this is not a Yonomi
            Platform limitation.
          </p>

          <div className="error-details">
            <div className="detail-row">
              <span className="detail-label">Email:</span>
              <span className="detail-value">{errorData.email}</span>
            </div>
            <div className="detail-row">
              <span className="detail-label">Existing Organization:</span>
              <span className="detail-value">{existingOrgName}</span>
            </div>
            <div className="detail-row">
              <span className="detail-label">Existing Organization ID:</span>
              <span className="detail-value">{errorData.existingOrgId}</span>
            </div>
            <div className="detail-row">
              <span className="detail-label">Current Organization:</span>
              <span className="detail-value">{organizationName}</span>
            </div>
            <div className="detail-row">
              <span className="detail-label">Current Organization ID:</span>
              <span className="detail-value">{errorData.currentOrgId}</span>
            </div>
          </div>

          <button className="copy-error-button" onClick={handleCopy}>
            {copied ? "✓ Copied!" : "📋 Copy Error Message"}
          </button>
        </div>

        <div className="duplicate-error-footer">
          <button className="close-modal-button" onClick={onBack}>
            Back
          </button>
        </div>
      </div>
    </div>
  );
};

export default DuplicatePatronErrorModal;
